/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimInfo
 */
export interface ClaimInfo {
    /**
     * 
     * @type {string}
     * @memberof ClaimInfo
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimInfo
     */
    value: string | null;
}

/**
 * Check if a given object implements the ClaimInfo interface.
 */
export function instanceOfClaimInfo(value: object): value is ClaimInfo {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ClaimInfoFromJSON(json: any): ClaimInfo {
    return ClaimInfoFromJSONTyped(json, false);
}

export function ClaimInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
    };
}

export function ClaimInfoToJSON(json: any): ClaimInfo {
    return ClaimInfoToJSONTyped(json, false);
}

export function ClaimInfoToJSONTyped(value?: ClaimInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

